import { render, staticRenderFns } from "./iconGitfCard.vue?vue&type=template&id=f52daf98&scoped=true"
import script from "./iconGitfCard.vue?vue&type=script&lang=js"
export * from "./iconGitfCard.vue?vue&type=script&lang=js"
import style0 from "./iconGitfCard.vue?vue&type=style&index=0&id=f52daf98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52daf98",
  null
  
)

export default component.exports